module.exports = __webpack_public_path__ + "static/coding_interactions_dynamic_11_dont-93ff1d8adfb8b5526f5f8ac61c368e9b.png";